import { Component, OnInit } from '@angular/core';
import { InjectConfig, ModelsExperienceConfigKey } from '@ddt-web/config-layer';
import { DateFormatter } from '@ddt-web/data-service';
import { DateUtil, InjectQueryParam } from '@ddt-web/generic-utils';
import { MeQueryParamKey, UrlService } from '@ddt-web/url';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { of } from 'rxjs';
import { take } from 'rxjs/operators';

import { ModelsBrowseDataService } from '../services';

@UntilDestroy()
@Component({
	selector: 'mb-family-esg-metrics',
	templateUrl: './family-esg-metrics.component.html',
	styleUrls: ['./family-esg-metrics.component.scss']
})
export class FamilyEsgMetricsComponent implements OnInit {
	@InjectQueryParam(MeQueryParamKey.FAMILY_ID) private readonly selectedFamilyId: string;
	@InjectConfig(ModelsExperienceConfigKey.DATE_FORMAT) private readonly dateFormat: string = DateUtil.MODELS_US_DATE_FORMAT;

	public asOfDate;
	public carbonScoreTab;
	public familyId;
	public familyIds$;
	public validEsgData: boolean;

	constructor(private urlService: UrlService, private modelBrowseDataService: ModelsBrowseDataService) {
	}

	public ngOnInit(): void {
		this.familyId = this.urlService.getModelFamilyId();
		this.familyIds$ = of([this.familyId]);
		this.loadEsgRatings();
	}

	public loadEsgRatings() {
		this.modelBrowseDataService.fetchESGModelsAnalytics(this.selectedFamilyId).pipe(take(1), untilDestroyed(this)).subscribe((esgData: any) => {
			this.validEsgData = esgData?.models?.some(item => !!item.esgScores);
			const asOfDate = esgData?.models?.[0]?.analysisDate;
			if (asOfDate) {
				this.asOfDate = new DateFormatter(this.dateFormat).format(asOfDate);
			}
		});
	}
} 
